/**
 * SectionNode — a freeform group ("Act I", "Act II", or any custom label)
 * writers can create, rename, resize, and drag cards into. Rendered as a
 * react-flow `type: 'group'`-style parent node; child cards set
 * `parentId`/`extent: 'parent'` to live inside it.
 */

import React, { useState } from 'react';
import { NodeResizer } from '@xyflow/react';
import { X } from 'lucide-react';

export default function SectionNode({ data, selected }) {
  const [title, setTitle] = useState(data.title);

  return (
    <div className="h-full w-full rounded-2xl border-2 border-dashed border-line/80 bg-cream/40">
      <NodeResizer
        isVisible={selected}
        minWidth={280}
        minHeight={200}
        lineClassName="!border-coral/40"
        handleClassName="!h-2.5 !w-2.5 !rounded-full !border-2 !border-card !bg-coral"
      />
      <div className="nodrag flex items-center justify-between gap-2 px-4 pt-3">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={() => data.onRename?.(title)}
          onClick={(e) => e.stopPropagation()}
          className="min-w-0 flex-1 truncate bg-transparent font-display text-sm font-semibold uppercase tracking-wide text-subtle outline-none focus:text-ink"
        />
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); data.onDelete?.(); }}
          aria-label="Delete section"
          className="grid h-6 w-6 shrink-0 place-items-center rounded-full text-subtle hover:bg-card hover:text-coral"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
